import {
  AllotCarToPilotRequest,
  CarDetailsFromVrnRequest,
  ListCarsFromTokenRequest,
} from "@/central-atoms/everest-fleet-pwa/requests";
import {
  AllotCarFromLoginTokenResponse,
  AllotmentHistoryResponse,
  CarDetailsResponse,
  CarListFromTokenResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { apiClient } from "../apiClient";

class AllotmentService {
  static async listCarsFromToken(
    reqBody: ListCarsFromTokenRequest
  ): Promise<CarListFromTokenResponse> {
    const response = await apiClient.post(`/car_list_from_login`, reqBody);
    return response.data;
  }

  static async carDetailsFromVrn(
    reqBody: CarDetailsFromVrnRequest
  ): Promise<CarDetailsResponse> {
    const response = await apiClient.post(`/car_details`, reqBody);
    return response.data;
  }

  static async allotCarToPilot(
    reqBody: AllotCarToPilotRequest
  ): Promise<AllotCarFromLoginTokenResponse> {
    const response = await apiClient.post(`/allot_car_from_login`, reqBody);
    return response.data;
  }

  static async getAllotmentHistory(
    hub: string,
    page: number,
    per_page: number,
    recent: number = 1
  ): Promise<AllotmentHistoryResponse> {
    const response = await apiClient.get(`/allotment_history`, {
      params: {
        recent,
        hub,
        page,
        per_page,
      },
    });
    return response.data;
  }
}

export default AllotmentService;
